<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Inspection', apiMethod: 'Inspections', form: () => import('../forms/InspectionForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Hive Removal', apiMethod: 'HiveRemovals', parentForeignKey: 'inspectionId', form: () => import('../forms/HiveRemovalForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Nuc', apiMethod: 'Nucs', parentForeignKey: 'inspectionId', form: () => import('../forms/NucForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Pest/Disease Test', apiMethod: 'AfflictionTests', parentForeignKey: 'inspectionId', form: () => import('../forms/AfflictionTestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Pest/Disease Sighting', apiMethod: 'AfflictionSightings', parentForeignKey: 'inspectionId', form: () => import('../forms/AfflictionSightingForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Site Treatment', apiMethod: 'SiteTreatments', parentForeignKey: 'inspectionId', form: () => import('../forms/SiteTreatmentForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Biosecurity Incidents', value: 'inspectionId', table: () => import('../tables/BiosecurityIncidentsTable') },
                    { text: 'Hive Removals', value: 'inspectionId', isCard: true, table: () => import('../tables/HiveRemovalsTable') },
                    { text: 'Nucs', value: 'inspectionId', isCard: true, table: () => import('../tables/NucsTable') },
                    { text: 'Pest/Disease Sightings', value: 'inspectionId', isCard: true, table: () => import('../tables/AfflictionSightingsTable') },
                    { text: 'Pest/Disease Tests', value: 'inspectionId', isCard: true, table: () => import('../tables/AfflictionTestsTable') },
                    { text: 'Site Treatments', value: 'inspectionId', isCard: true, table: () => import('../tables/SiteTreatmentsTable') },
                ],
                mainForm: () => import('../forms/InspectionForm'),
                claimName: 'Inspections',
                apiMethod: 'Inspections',
            }
        }
    };
</script>
